import { render } from "./CustomMadeView.vue?vue&type=template&id=d34e335a&ts=true"
import script from "./CustomMadeView.vue?vue&type=script&lang=ts"
export * from "./CustomMadeView.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__